import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DesignEditorPrimaryControls = ({ className, children }) => {
  const classes = classNames({
    'design-editor-primary-controls': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

DesignEditorPrimaryControls.propTypes = propTypes;

export default DesignEditorPrimaryControls;
